import { render, staticRenderFns } from "./AdminDepositBankAccountIndexPageTableActions.vue?vue&type=template&id=37fba441&"
import script from "./AdminDepositBankAccountIndexPageTableActions.vue?vue&type=script&lang=ts&"
export * from "./AdminDepositBankAccountIndexPageTableActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports